import { Link } from "react-router-dom";

interface Props {
  to: string;
  ariaLabel?: string;
  onMouseEnter: () => void;
  onMouseLeave: () => void;
  /** If not defined, will use onMouseEnter */
  onFocus?: () => void;
  /** If not defined, will use onMouseLave */
  onBlur?: () => void;
  children: React.ReactNode;
}

/**
 * Link wrapper to enable custom side effects onMouseHover/Leave and Focus/Blur
 * @param param0
 * @returns
 */
export const HoverableLink: React.FC<Props> = ({
  to,
  ariaLabel,
  onMouseEnter,
  onMouseLeave,
  onFocus,
  onBlur,
  children,
}) => {
  return (
    <Link
      to={to}
      aria-label={ariaLabel}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onFocus={onFocus ?? onMouseEnter}
      onBlur={onBlur ?? onMouseLeave}
      state={{ prevPage: "/discover" }}
    >
      {children}
    </Link>
  );
};
